import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-deposit-delay-info',
  templateUrl: './deposit-delay-info.component.html',
  styleUrls: ['./deposit-delay-info.component.scss'],
  standalone: false
})
export class DepositDelayInfoComponent {
  @Input() addMargin = true;
  constructor(
    private trackingService: TrackingService,
    private router: Router
  ) {}

  onHelp() {
    this.trackingService.trackActivity('[Link] Deposit delay info: Open help');
    void this.router.navigate(['/help']);
  }
}
